import Marquee from "react-fast-marquee";
import { MARQUEE } from "../../lib/content";

export const BrandMarquee = () => (
  <div className="relative border-y border-white/10 bg-bf-surface/40 py-8" data-testid="brand-marquee">
    <Marquee speed={38} gradient gradientColor="#050505" gradientWidth={120}>
      {MARQUEE.concat(MARQUEE).map((word, i) => (
        <span key={i} className="mx-8 inline-flex items-center gap-8">
          <span className="font-display text-2xl md:text-4xl font-bold tracking-tight text-white/25 hover:text-white/70 transition-colors duration-300">
            {word}
          </span>
          <span className="h-2 w-2 rotate-45 bg-bf-yellow/60" />
        </span>
      ))}
    </Marquee>
  </div>
);
